import { Icon16HelpOutline } from '@vkontakte/icons';
import { Title } from '@vkontakte/vkui';
import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getYearCurrentGroupConfig, isYearCurrentGroupFilter } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.selectors';
import { QuotaCleanerYears } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.types';
import { useYearFilter } from 'reactApp/ui/QuotaCleanerPage/hooks/useYearFilter';
import { QuotaCleanerTooltip } from 'reactApp/ui/QuotaCleanerTooltip/QuotaCleanerTooltip';
import { getSize } from 'reactApp/utils/sizeHelper';

import styles from './Header.css';

interface HeaderProps {
    title: string;
    hint?: string;
    size: number;
}

export const Header: FC<HeaderProps> = ({ title, hint, size }) => {
    const yearConfig = useSelector(getYearCurrentGroupConfig);
    const isYearFilter = useSelector(isYearCurrentGroupFilter);
    const year = yearConfig?.currentYear;

    const { toggleIsDropdownListOpen } = useYearFilter();

    const onClick = useCallback(() => {
        toggleIsDropdownListOpen();
    }, [toggleIsDropdownListOpen]);

    return (
        <div className={styles.root}>
            <div className={styles.title}>
                <Title level="1" weight="2">
                    {title}
                </Title>
                &ensp;
                {isYearFilter && year && year !== QuotaCleanerYears.All && (
                    <Title level="1" weight="2" className={styles.subTitle} onClick={onClick}>
                        за {year} год
                    </Title>
                )}
                {hint && (
                    <QuotaCleanerTooltip text={hint}>
                        <Icon16HelpOutline
                            className={styles.hintIcon}
                            onClick={(event) => {
                                event.stopPropagation();
                            }}
                        />
                    </QuotaCleanerTooltip>
                )}
            </div>
            {!!size && (
                <Title level="3" weight="2">
                    Занято: {getSize(size)}
                </Title>
            )}
        </div>
    );
};
